import { MeetingDays } from "../dtos/classes.type";

export function getAgeLabelByAgeValue(label: string): string {
  const regex = /P(\d+)Y\d+M-P(\d+)Y\d+M/;
  const match = label.match(regex);

  if (match) {
    const startYear = parseInt(match[1]);
    const endYear = parseInt(match[2]);

    if (startYear === endYear) {
      return `Age ${startYear} (Kids)`;
    } else if (startYear >= 7 && endYear >= 7) {
      return `Age ${startYear}-${endYear} (Children)`;
    } else {
      return `Age ${startYear}-${endYear} (Kids)`;
    }
  }
  return label;
}

export function getValueByAgeCode(timeString: string): string {
  const match = timeString.match(/P(\d+)Y(\d+)M/);

  if (!match) {
    return timeString; // Return original string if no match
  }

  const years = parseInt(match[1]);
  const months = parseInt(match[2]);

  const formattedYears = years > 0 ? `${years}Y` : "";
  const formattedMonths = `${months || 0}M`;

  return `${formattedYears}${formattedMonths}`;
}

export function getDayByProperty(meeting_days: MeetingDays): string {
  switch (true) {
    case meeting_days.mon:
      return "Monday";
    case meeting_days.tue:
      return "Tuesday";
    case meeting_days.wed:
      return "Wednesday";
    case meeting_days.thu:
      return "Thursday";
    case meeting_days.fri:
      return "Friday";
    case meeting_days.sat:
      return "Saturday";
    case meeting_days.sun:
      return "Sunday";
    default:
      return "";
  }
}

export function convertAgeRange(range: string): string {
  const [start, end] = range.split("-");

  const startYears = parseInt(start.substring(1, 3));
  const startMonths = parseInt(start.substring(4, 6));
  const endYears = parseInt(end.substring(1, 3));
  const endMonths = parseInt(end.substring(4, 6));

  if (endYears === 99) {
    return `${startYears}+`;
  }

  if (startMonths === 0 && endMonths === 0) {
    return `${startYears}-${endYears}`;
  }

  if (startYears === 0) {
    const startFormatted = `${startMonths}m`;
    return `${startFormatted} to ${endYears}`;
  }

  return `${startYears}-${endYears}`;
}

export function parseAge(ageString: string) {
  const match = ageString.match(/P(\d+)Y(\d+)M-P(\d+)Y(\d+)M/);
  if (match) {
    const startMonths = parseInt(match[1]) * 12 + parseInt(match[2]);
    const endMonths = parseInt(match[3]) * 12 + parseInt(match[4]);
    return {
      start: startMonths,
      end: endMonths,
    };
  }
  return { start: 0, end: 0 }; // Return a default range if no match
}

export function getClassesPerWeek(meetingDays: MeetingDays): number {
  return Object.values(meetingDays).reduce(
    (count, value) => count + (value ? 1 : 0),
    0
  );
}
